/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Event_BeforeInputs */



/**
* | output |
* | --- |
* | "Event Before" |
*
* @param {Event_BeforeInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const event_before = /** @type {((inputs?: Event_BeforeInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Event_BeforeInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Événement avant")
	if (locale === "de") return /** @type {LocalizedString} */ ("Vorher")
	if (locale === "it") return /** @type {LocalizedString} */ ("Evento prima")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Событие до")
	if (locale === "es") return /** @type {LocalizedString} */ ("Evento anterior")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("事件发生前")
	if (locale === "ja") return /** @type {LocalizedString} */ ("イベント前")
	if (locale === "hi") return /** @type {LocalizedString} */ ("इससे पहले की घटना")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Evento anterior")
	return /** @type {LocalizedString} */ ("Event Before")
});